import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import Darkmode from '../DarkMode/Darkmode';
import lightlogo from "../../Img/light-mode-logo.png";
import darkLogo from "../../Img/reglogo.png";
import { Link } from "react-router-dom";
import { ThemeContext } from '../DarkMode/ThemeProvider';
import { useContext } from 'react';

const pages = ['Products', 'Pricing', 'Blog'];
// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function AuthHeader() {

  const { isLightMode, handleDarkmode } = useContext(ThemeContext);


  return (
    <AppBar position="static" sx={{boxShadow:"none"}}>
      <Container maxWidth="xxl">
        <Toolbar disableGutters sx={{width:"100%"}}>
            <div className="display-2 auth-logo" style={{width:"100%"}}>
        <div className="logo head">
                            <Link to="/">
                                <img src={isLightMode ? darkLogo : lightlogo} />
                            </Link>
                        </div>
              <Box sx={{ flexGrow: 1,textAlign:"right" }}>
            <Tooltip title="Darkmode">
            
              <Darkmode/>
      </Tooltip>
    
          </Box>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default AuthHeader;
